/**
 * پیکربندی متمرکز برنامه.
 *
 * مقادیر از متغیرهای محیطی (VUE_APP_*) خوانده می‌شوند و در نبود آن‌ها
 * مقدار پیش‌فرض فعلی به‌کار می‌رود تا چیزی نشکند.
 */

const env = (typeof process !== "undefined" && process.env) || {};

export const apiBasePath = env.VUE_APP_API_BASE || "/api/";

// در محیط توسعه لاگ‌های تشخیصی نشان داده شوند
export const isDev = env.NODE_ENV !== "production";

// پایش خطای کلاینت — فقط از طریق endpoint داخلی POST /api/LogEvent
// (همان LogEventController در پروژه‌ی BNDBS.WebServices). هیچ سرویس بیرونی‌ای در کار نیست.
// این کلید همان Key پروژه در جدول ProjectMonitor است. بدون آن، خطاها فقط در کنسول می‌مانند.
export const logEventKey = env.VUE_APP_LOGEVENT_KEY || "";

export const appRelease = env.VUE_APP_RELEASE || env.BUILD_VERSION || "";

export default {
    apiBasePath,
    isDev,
    logEventKey,
    appRelease,
};
